"use strict";
/**
 * Constants
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.errors = exports.STRICT_AUTHORISATION = exports.TIMEOUT = exports.VERSION = exports.TLS = exports.API_URL = void 0;
/**
 * Default API endpoint
 */
exports.API_URL = "api.ideal-postcodes.co.uk";
/**
 * Use TLS by default. Set to `true`
 */
exports.TLS = true;
/**
 * Default API Version number. Defaults to "v1"
 */
exports.VERSION = "v1";
/**
 * Default HTTP timeout in milliseconds. Defaults to 10s
 */
exports.TIMEOUT = 10000;
/*
 * STRICT_AUTHORISATION forces authorization header usage on
 * autocomplete API which increases latency due to overhead
 * OPTIONS request
 */
exports.STRICT_AUTHORISATION = false;
var client_1 = require("./client");
Object.defineProperty(exports, "Client", { enumerable: true, get: function () { return client_1.Client; } });
var errors = __importStar(require("./error"));
exports.errors = errors;
//# sourceMappingURL=index.js.map